import { iconLoader, iconLogo } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon } from '../icon/icon.js';
export const Loader = ({ className, label, show, fullscreen, ...rest }) => (React.createElement("div", { "aria-busy": show ? 'true' : undefined, "aria-hidden": !show, "aria-label": label || 'Loading', "aria-live": show ? 'polite' : undefined, className: cx('tds-loader', {
        'tds-loader--show': show,
        'tds-loader--fullscreen': fullscreen,
    }, className), role: show ? 'progressbar' : undefined, ...rest },
    React.createElement(Icon, { data: iconLoader }),
    React.createElement(Icon, { data: iconLogo })));
